/**
 * Shielded Universal Cleaner
 * Gives custom elements (like the Gift app) a safety pass to load.
 */
function cleanAppBlocks(isInitialPass) {
  const appBlocks = document.querySelectorAll('.shopify-app-block, .product__block--app');

  appBlocks.forEach(block => {
    // 1. Check for Custom Elements (tags with a hyphen)
    const customTags = block.querySelectorAll('*:not(style):not(script)');
    const hasCustomAppTag = Array.from(customTags).some(el => el.tagName.includes('-'));

    // 2. Visibility Checks
    const textContent = block.innerText.trim();
    const hasVisibleText = textContent.length > 0;
    
    const interactiveElements = block.querySelectorAll('input, button, select, a, svg, img');
    const hasVisibleElements = Array.from(interactiveElements).some(el => {
      const style = window.getComputedStyle(el);
      return el.offsetHeight > 0 && style.display !== 'none';
    });

    // THE LOGIC:
    // If it's the first 5 seconds AND we see a custom tag (like <wrapped-gift-block>),
    // we SHIELD it and keep it visible no matter what.
    if (isInitialPass && hasCustomAppTag) {
      showBlock(block);
      return;
    }

    // After the grace period, or for non-custom apps:
    if (hasVisibleText || hasVisibleElements || (hasCustomAppTag && block.offsetHeight > 5)) {
      showBlock(block);
    } else {
      hideBlock(block);
    }
  });
}

function hideBlock(el) {
  el.style.setProperty('display', 'none', 'important');
  el.style.setProperty('margin', '0', 'important');
}

function showBlock(el) {
  el.style.display = "";
  el.style.margin = "";
}

function initShieldedCleaner() {
  // Run with "Safety Pass" active for the first 5 seconds
  let attempts = 0;
  const interval = setInterval(() => {
    const isInitialPass = attempts < 10; // 10 attempts * 500ms = 5 seconds
    cleanAppBlocks(isInitialPass);
    attempts++;
    if (attempts > 30) clearInterval(interval);
  }, 500);
}

document.addEventListener('DOMContentLoaded', initShieldedCleaner);